// src/components/Navbar.js
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function Navbar() {
  const { logout, userPlan, isPaid } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    toast.success('Logged out');
  }

  return (
    <nav className="nav">
      <div className="nav-brand">
        <span>🐄</span> Gaushala Manager
      </div>
      <NavLink to="/" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} end>Dashboard</NavLink>
      <NavLink to="/cattle" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Records</NavLink>
      <NavLink to="/import" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Import</NavLink>
      <NavLink to="/search" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>Search</NavLink>
      {!isPaid && (
        <NavLink to="/upgrade" className="btn btn-amber" style={{ marginLeft: 4, padding: '6px 12px', fontSize: 12 }}>⭐ Upgrade</NavLink>
      )}
      {isPaid && (
        <span className="plan-badge plan-paid" style={{ marginLeft: 8 }}>✓ Pro</span>
      )}
      <button onClick={handleLogout} className="btn btn-secondary" style={{ marginLeft: 8, padding: '6px 12px', fontSize: 13 }}>
        Logout
      </button>
    </nav>
  );
}
